"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.observeAppState = void 0;
const store_1 = require("@completeanatomy/store");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const typedi_1 = require("typedi");
/**
 * Add listener on AppState changes
 *
 * @param selector - selector function to listen on substate
 * @param onChange - callback
 *
 * @returns <() => void> — unsubscribe function
 */
function observeAppState(selector, onChange) {
    let currentValue;
    const store = typedi_1.Container.get(store_1.StoreToken);
    const handleChange = () => {
        const state = store.getState();
        const nextValue = selector(state);
        if (!(0, isEqual_1.default)(currentValue, nextValue)) {
            onChange(nextValue);
        }
        currentValue = nextValue;
    };
    const unsubscribe = store.subscribe(handleChange);
    handleChange();
    return unsubscribe;
}
exports.observeAppState = observeAppState;
